import { Component, OnInit, inject } from '@angular/core';
import { AuthService } from '../../core/auth';

/**
 * Handles the Okta `/login/callback` redirect and routes to Shipment Creation when successful.
 */
@Component({
  selector: 'app-login-callback',
  template: '',
})
export class LoginCallback implements OnInit {
  private readonly auth = inject(AuthService);

  /**
   * Completes the Okta redirect handshake after the callback route activates.
   * Uses a void-returning `ngOnInit` (OnInit contract) and handles the Promise via `.catch`.
   */
  ngOnInit(): void {
    this.auth.handleLoginCallback().catch(() => undefined);
  }
}
